import { ReactNode, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface PortalProps {
  children: ReactNode;
}

export function Portal(props: PortalProps) {
  const modalRoot = document.getElementById('modals');
  const element = document.createElement('div');

  useEffect(() => {
    if (!modalRoot) return;

    modalRoot.appendChild(element);

    return () => {
      modalRoot.appendChild(element);
    };
  }, [modalRoot, element]);

  return ReactDOM.createPortal(props.children, element);
}
